/**
 * @author Fernando Ruano
 * @file endpoints.js
 * @description Endpoints App File
 */

// Environments
const nephroAuthApiUrl = window.env_file.REACT_APP_API_NEPHRO_AUTH_BASE_URL;
const nephroMasterApiUrl = window.env_file.REACT_APP_API_NEPHRO_MASTER_BASE_URL;
const nephroIntegratorApiUrl =
  window.env_file.REACT_APP_API_NEPHRO_INTEGRATOR_BASE_URL;
const nephroCalendarApiUrl =
  window.env_file.REACT_APP_API_NEPHRO_CALENDAR_BASE_URL;
const nephroMediaApiUrl = window.env_file.REACT_APP_API_NEPHRO_MEDIA_BASE_URL;
const nephroCommonApiUrl = window.env_file.REACT_APP_API_NEPHRO_COMMON_BASE_URL;

export default {
  authentication: {
    login: `${nephroAuthApiUrl}/users/auth`,
    resetPassword: `${nephroAuthApiUrl}/users/passwordReset`,
    resetPasswordRegister: `${nephroAuthApiUrl}/users/passwordResetRegister`,
    activatePatientByRegister: `${nephroAuthApiUrl}/users/activeUserEncoded`,
    create: `${nephroAuthApiUrl}/users/create`,
    recoverPassword: `${nephroAuthApiUrl}/users/passwordEmail`,
    getClaims: `${nephroAuthApiUrl}/users/getClaims`,
    userList: `${nephroAuthApiUrl}/users/list`,
    signOut: `${nephroAuthApiUrl}/users/logout`,
    // MFA
    factor: {
      challenge: `${nephroAuthApiUrl}/users/auth/challenge`,
      verify: `${nephroAuthApiUrl}/users/auth/verify`
    },
    requestToken: `${nephroAuthApiUrl}/users/token`,
    autoEnrollFactor: `${nephroAuthApiUrl}/users/auth/enroll`
  },
  role: {
    base: `${nephroMasterApiUrl}/role`
  },
  parameter: {
    base: `${nephroMasterApiUrl}/parameters`,
    findByKey: `${nephroMasterApiUrl}/parameters/findByKey`
  },
  medicalParameter: {
    base: `${nephroMasterApiUrl}/medical-parameters-nephro`
  },
  permission: {
    base: `${nephroMasterApiUrl}/permission`
  },
  rolePermission: {
    base: `${nephroMasterApiUrl}/role-permission`
  },
  countryUserRole: {
    base: `${nephroMasterApiUrl}/country-user-role`
  },
  user: {
    base: `${nephroMasterApiUrl}/user`,
    getUserByEmail: `${nephroMasterApiUrl}/user/getUserByEmail`,
    userLogin: `${nephroMasterApiUrl}/getUserData`,
    userDataRegister: `${nephroMasterApiUrl}/getUserDataRegister`,
    validatePermission: `${nephroMasterApiUrl}/user/validatePermission`
  },
  patient: {
    base: `${nephroMasterApiUrl}/patient`,
    getAllPatients: `${nephroMasterApiUrl}/patient/allPatients`,
    typeId: `${nephroMasterApiUrl}/identification-type`,
    statusList: `${nephroMasterApiUrl}/patient/listAllPatientSatus`,
    updatePatientStatus: `${nephroMasterApiUrl}/patient/updatePatientStatusById`,
    validateById: `${nephroMasterApiUrl}/patient/getPatientByIdDocument`,
    validateEmailById: `${nephroMasterApiUrl}/patient/getEmailPatientByIdDocument`,
    patientIndicators: `${nephroMasterApiUrl}/patient/listIndicadorByIdPatient`,
    PTHPatient: `${nephroMasterApiUrl}/patient/getPthPatient`,
    eventsByPatientId: `${nephroMasterApiUrl}/patient/listEventsByIdPatient`,
    filter: `${nephroMasterApiUrl}/patient/pagedPatientByFilter`,
    extraDataById: `${nephroMasterApiUrl}/patient/patientExtraDataById`,
    upcomingVideoCalls: `${nephroMasterApiUrl}/patient/getUpcomingVideoCalls`,
    patientLastAppointment: `${nephroMasterApiUrl}/patient/patientLastAppointment`,
    sendMassInvitation: `${nephroMasterApiUrl}/patientMassInvitation/massInvitation`,
    patientMProcessing: `${nephroMasterApiUrl}/patientMProcessing`,
    patientMProcessDetail: `${nephroMasterApiUrl}/patientMProcessDetail/listDetailsByIdProcess`
  },
  dashboardStaff: {
    recommendedByScheduling: {
      base: `${nephroMasterApiUrl}/patient/indiPacientesRecomendadosAgendarF6`,
      list: `${nephroMasterApiUrl}/patient/indiPacientesRecomendadosAgendarF6Lista`,
      plus: `${nephroMasterApiUrl}/patient/indiPacientesRecomendadosAgendarF6ListaPlus`
    },
    missedAppointmentsByStage: {
      base: `${nephroMasterApiUrl}/patient/indiIncumplimientoCitaEstadioF7`,
      list: `${nephroMasterApiUrl}/patient/indiIncumplimientoCitaEstadioF7Lista`,
      plus: `${nephroMasterApiUrl}/patient/indiIncumplimientoCitaEstadioF7ListaPlus`
    },
    antibodyAntiHBs: {
      base: `${nephroMasterApiUrl}/patient/indiAntihbsF10`,
      list: `${nephroMasterApiUrl}/patient/indiAntiHbsF10Lista`,
      plus: `${nephroMasterApiUrl}/patient/indiAntiHbsF10ListaPlus`
    },
    indiBloodPressureMonitoring: {
      base: `${nephroMasterApiUrl}/patient/indiBloodPressureMonitoringAlertF43`,
      list: `${nephroMasterApiUrl}/patient/indiBloodPressureMonitoringAlertF43Data`,
      plus: `${nephroMasterApiUrl}/patient/indiBloodPressureMonitoringAlertF43DataPlus`
    },
    indiGlucoseMonitoring: {
      base: `${nephroMasterApiUrl}/patient/indiGlucoseMonitoringAlertsF43`,
      list: `${nephroMasterApiUrl}/patient/indiGlucoseMonitoringAlertsF43Data`,
      plus: `${nephroMasterApiUrl}/patient/indiGlucoseMonitoringAlertsF43DataPlus`
    },
    albuminuriaF13: {
      base: `${nephroMasterApiUrl}/patient/indiAlbuminuriaF13`,
      list: `${nephroMasterApiUrl}/patient/indiAlbuminuriaF13Lista`,
      plus: `${nephroMasterApiUrl}/patient/indiAlbuminuriaF13ListaPlus`
    },
    albuminuriaProgress: {
      base: `${nephroMasterApiUrl}/patient/indiAlbuminuriaF14`,
      list: `${nephroMasterApiUrl}/patient/indiAlbuminuriaF14Lista`,
      plus: `${nephroMasterApiUrl}/patient/indiAlbuminuriaF14ListaPlus`
    },
    TFGDeterioration: {
      base: `${nephroMasterApiUrl}/patient/indiDeteroroTfgF16`,
      list: `${nephroMasterApiUrl}/patient/indideterioroTfgF16Lista`,
      plus: `${nephroMasterApiUrl}/patient/indideterioroTfgF16ListaPlus`
    },
    nutritionalIndicator: {
      base: `${nephroMasterApiUrl}/patient/indiNutritionalF27`,
      list: `${nephroMasterApiUrl}/patient/indiNutritionalF27Lista`,
      plus: `${nephroMasterApiUrl}/patient/indiNutritionalF27ListaPlus`
    },
    hemoglobin: {
      base: `${nephroMasterApiUrl}/patient/indiHemoglobinaF29`,
      list: `${nephroMasterApiUrl}/patient/indiHemoglobinaF29Lista`,
      plus: `${nephroMasterApiUrl}/patient/indiHemoglobinaF29ListaPlus`
    },
    potassium: {
      base: `${nephroMasterApiUrl}/patient/indiPotassiumF31`,
      list: `${nephroMasterApiUrl}/patient/indiPotassiumF31List`,
      plus: `${nephroMasterApiUrl}/patient/indiPotassiumF31ListPlus`
    },
    proteinuria: {
      base: `${nephroMasterApiUrl}/patient/indiProteinuriaF15`,
      list: `${nephroMasterApiUrl}/patient/indiProteinuriaF15Lista`,
      plus: `${nephroMasterApiUrl}/patient/indiProteinuriaF15ListaPlus`
    },
    metabolicControlDiabetes: {
      base: `${nephroMasterApiUrl}/patient/indiMetabolicControlDiabetesF21`,
      list: `${nephroMasterApiUrl}/patient/indiMetabolicControlDiabetesF21List`,
      plus: `${nephroMasterApiUrl}/patient/indiMetabolicControlDiabetesF21ListPlus`
    },
    phosphorus: {
      base: `${nephroMasterApiUrl}/patient/indiPhosphorusF30`,
      list: `${nephroMasterApiUrl}/patient/indiPhosphorusF30List`,
      plus: `${nephroMasterApiUrl}/patient/indiPhosphorusF30ListPlus`
    },
    albumina: {
      base: `${nephroMasterApiUrl}/patient/indiAlbuminaF28`,
      list: `${nephroMasterApiUrl}/patient/indiAlbuminaF28Lista`,
      plus: `${nephroMasterApiUrl}/patient/indiAlbuminaF28ListaPlus`
    },
    pthIndicator: {
      base: `${nephroMasterApiUrl}/patient/indiPthF32`,
      list: `${nephroMasterApiUrl}/patient/indiPthF32List`,
      plus: `${nephroMasterApiUrl}/patient/indiPthF32ListPlus`
    },
    seroStatusHepatitisB: {
      base: `${nephroMasterApiUrl}/patient/indiZeroStatusHepatitisBF8`,
      list: `${nephroMasterApiUrl}/patient/indiZeroStatusHepatitisBF8List`,
      plus: `${nephroMasterApiUrl}/patient/indiZeroStatusHepatitisBF8ListPlus`
    },
    risk: {
      base: `${nephroMasterApiUrl}/patient/indiRiskF17`,
      list: `${nephroMasterApiUrl}/patient/indiRiskF17List`,
      plus: `${nephroMasterApiUrl}/patient/indiRiskF17ListPlus`
    },
    bloodPressure: {
      base: `${nephroMasterApiUrl}/patient/indiBloodPressureControlF20`,
      list: `${nephroMasterApiUrl}/patient/indiBloodPressureControlF20List`,
      plus: `${nephroMasterApiUrl}/patient/indiBloodPressureControlF20ListPlus`
    },
    vaccineScheduling: {
      base: `${nephroMasterApiUrl}/patient/indiVaccineSchedulingF9`,
      list: `${nephroMasterApiUrl}/patient/indindiVaccineSchedulingF9List`,
      plus: `${nephroMasterApiUrl}/patient/indindiVaccineSchedulingF9ListPlus`
    },
    postVaccineAntiHbs: {
      base: `${nephroMasterApiUrl}/patient/indiPostVaccineAntiHbsF11`,
      list: `${nephroMasterApiUrl}/patient/indiPostVaccineAntiHbsF11List`,
      plus: `${nephroMasterApiUrl}/patient/indiPostVaccineAntiHbsF11ListPlus`
    },
    riskRegister: {
      base: `${nephroMasterApiUrl}/patient/indiRiskRegisterF19`,
      list: `${nephroMasterApiUrl}/patient/indiRiskRegisterF19Data`,
      plus: `${nephroMasterApiUrl}/patient/indiRiskRegisterF19DataPlus`
    },
    lossHepatitisImmunity: {
      base: `${nephroMasterApiUrl}/patient/indiLossHepatitisImmunityF12`,
      list: `${nephroMasterApiUrl}/patient/indiLossHepatitisImmunityF12Data`,
      plus: `${nephroMasterApiUrl}/patient/indiLossHepatitisImmunityF12DataPlus`
    },
    correlationRiskRateProgression: {
      base: `${nephroMasterApiUrl}/patient/indiCorrelationRiskRateProgressionF18`,
      list: `${nephroMasterApiUrl}/patient/indiCorrelationRiskRateProgressionF18List`,
      plus: `${nephroMasterApiUrl}/patient/indiCorrelationRiskRateProgressionF18ListPlus`
    },
    treatmentOptions: {
      base: `${nephroMasterApiUrl}/patient/indiTreatmentOptionsF23`,
      list: `${nephroMasterApiUrl}/patient/indiTreatmentOptionsF23List`,
      plus: `${nephroMasterApiUrl}/patient/indiTreatmentOptionsF23ListPlus`
    },
    psychosocialRiskPsychology: {
      base: `${nephroMasterApiUrl}/patient/indiPsychosocialRiskPsychologyF34`,
      list: `${nephroMasterApiUrl}/patient/indiPsychosocialRiskPsychologyF34List`,
      plus: `${nephroMasterApiUrl}/patient/indiPsychosocialRiskPsychologyF34ListPlus`
    },
    access: {
      base: `${nephroMasterApiUrl}/patient/indiAccessF22`,
      list: `${nephroMasterApiUrl}/patient/indiAccessF22Data`,
      plus: `${nephroMasterApiUrl}/patient/indiAccessF22DataPlus`
    },
    schedulingAlert: {
      base: `${nephroMasterApiUrl}/patient/indiSchedulingAlertF25`,
      list: `${nephroMasterApiUrl}/patient/indiSchedulingAlertF25Data`,
      plus: `${nephroMasterApiUrl}/patient/indiSchedulingAlertF25DataPlus`
    },
    proteinEnergeticWear: {
      base: `${nephroMasterApiUrl}/patient/indiProteinEnergeticWearF26`,
      list: `${nephroMasterApiUrl}/patient/indiProteinEnergeticWearF26Data`,
      plus: `${nephroMasterApiUrl}/patient/indiProteinEnergeticWearF26DataPlus`
    },
    generalSocialTSocialRisk: {
      base: `${nephroMasterApiUrl}/patient/indiGeneralSocialTSocialRiskF38`,
      list: `${nephroMasterApiUrl}/patient/indiGeneralSocialTSocialRiskF38List`,
      plus: `${nephroMasterApiUrl}/patient/indiGeneralSocialTSocialRiskF38ListPlus`
    },
    nursingEducation: {
      base: `${nephroMasterApiUrl}/patient/indiNursingEducationF33`,
      list: `${nephroMasterApiUrl}/patient/indiNursingEducationF33List`,
      plus: `${nephroMasterApiUrl}/patient/indiNursingEducationF33Plus`
    },
    assessmentInPsychology: {
      base: `${nephroMasterApiUrl}/patient/indiAssessmentInPsychologyF37`,
      list: `${nephroMasterApiUrl}/patient/indiAssessmentInPsychologyF37List`
    },
    dissentWithoutPsychology: {
      base: `${nephroMasterApiUrl}/patient/indiDissentWithoutPsychologyAssessmentF36`,
      list: `${nephroMasterApiUrl}/patient/indiDissentWithoutPsychologyAssessmentF36Data`,
      plus: `${nephroMasterApiUrl}/patient/indiDissentWithoutPsychologyAssessmentF36DataPlus`
    },
    patientEvents: {
      base: `${nephroMasterApiUrl}/patient/indiPatientEventsF41`,
      list: `${nephroMasterApiUrl}/patient/indiPatientEventsF41Data`,
      plus: `${nephroMasterApiUrl}/patient/indiPatientEventsF41DataPlus`
    },
    periodicityAttention: {
      base: `${nephroMasterApiUrl}/patient/indiPeriodicityAttentionF40`,
      list: `${nephroMasterApiUrl}/patient/indiPeriodicityAttentionF40Data`
    },
    psychosocialRisk: {
      base: `${nephroMasterApiUrl}/patient/indiPsychosocialRiskF35`,
      list: `${nephroMasterApiUrl}/patient/indiPsychosocialRiskF35Data`,
      plus: `${nephroMasterApiUrl}/patient/indiPsychosocialRiskF35DataPlus`
    },
    constructionAccessAssessment: {
      base: `${nephroMasterApiUrl}/patient/indiConstructionAccessAssessmentF24`,
      list: `${nephroMasterApiUrl}/patient/indiConstructionAccessAssessmentF24List`,
      plus: `${nephroMasterApiUrl}/patient/indiConstructionAccessAssessmentF24ListPlus`
    },
    generalSocialRiskRegister: {
      base: `${nephroMasterApiUrl}/patient/indiGeneralSocialRiskRegisterF42`,
      list: `${nephroMasterApiUrl}/patient/indiGeneralSocialRiskRegisterF42Data`,
      plus: `${nephroMasterApiUrl}/patient/indiGeneralSocialRiskRegisterF42Plus`
    },
    followUpAbsenteeismAdherence: {
      base: `${nephroMasterApiUrl}/patient/indiFollowUpAbsenteeismAdherenceF39`,
      list: `${nephroMasterApiUrl}/patient/indiFollowUpAbsenteeismAdherenceF39List`,
      plus: `${nephroMasterApiUrl}/patient/indiFollowUpAbsenteeismAdherenceF39ListPlus`
    }
  },
  patientEvent: {
    base: `${nephroMasterApiUrl}/patientEvent`,
    eventTypes: `${nephroMasterApiUrl}/patientEvent/listEventTypes`
  },
  profile: {
    base: `${nephroMasterApiUrl}/profile`
  },
  menu: {
    base: `${nephroMasterApiUrl}/getAllMenus`,
    byRole: `${nephroMasterApiUrl}/getAllMenus?rolId=`,
    byRoleMenu: `${nephroMasterApiUrl}/getMenuByRol`,
    byUser: `${nephroMasterApiUrl}/getMenuByUser`
  },
  componentsState: {
    nephroMasterState: `${nephroMasterApiUrl}/isAlive`,
    nephroAuthState: `${nephroAuthApiUrl}/isAlive`,
    nephroIntegratorState: `${nephroIntegratorApiUrl}/isAlive`,
    nephroCalendarState: `${nephroCalendarApiUrl}/isAlive`,
    nephroMediaState: `${nephroMediaApiUrl}/isAlive`,
    nephroCommonState: `${nephroCommonApiUrl}/isAlive`
  },
  calendar: {
    getPatient: `${nephroCalendarApiUrl}/agendaMateController/getPatient`,
    patientAppointments: `${nephroCalendarApiUrl}/agendaMateController/getPatientAppointments?patientId=`,
    appointmentAvailability: `${nephroCalendarApiUrl}/agendaMateController/getAppointmentAvailability`,
    scheduleAppointment: `${nephroCalendarApiUrl}/agendaMateController/scheduleAppointment`,
    reScheduleAppointment: `${nephroCalendarApiUrl}/agendaMateController/reScheduleAppointment`,
    cancelAppointment: `${nephroCalendarApiUrl}/agendaMateController/cancelAppointment`
  },
  appointmentsZoom: {
    getAvailableAppointments: `${nephroCalendarApiUrl}/appointmentController/getAvailableAppointments`,
    scheduleAppointment: `${nephroCalendarApiUrl}/appointmentController/scheduleAppointment`,
    reScheduleAppointment: `${nephroCalendarApiUrl}/appointmentController/rescheduleAppointment`,
    cancelAppointment: `${nephroCalendarApiUrl}/appointmentController/cancelAppointment`,
    getZoomVideoCallById: `${nephroMasterApiUrl}/videoCallController/getVideoCallByIdAppointment`
  },
  glucometry: {
    base: `${nephroMasterApiUrl}/glucometryControl`
  },
  bloodPressure: {
    base: `${nephroMasterApiUrl}/bloodPressure`
  },
  educationalMaterial: {
    element: `${nephroMasterApiUrl}/educationalElement`,
    elementByCategoryId: `${nephroMasterApiUrl}/educationalElement/listEducationalElementByIdCategory`,
    category: `${nephroMasterApiUrl}/educationCategory`,
    s3: `${nephroMediaApiUrl}/s3`
  },
  versia: {
    clinics: `${nephroMasterApiUrl}/versia/getAdmonCodesByEntity`,
    lastUpdate: `${nephroMasterApiUrl}/versia/lastUpdate`
  },
  clinicPhones: {
    base: `${nephroMasterApiUrl}/clinicPhones`,
    clinicByName: `${nephroMasterApiUrl}/clinicPhones/getClinicPhones`
  }
};
